import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { store } from "./utils/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { ThemeProvider } from "@material-ui/core";
import { theme } from "./utils/styles";
import smoothscroll from "smoothscroll-polyfill";
import "rc-rate/assets/index.css";
import ErrorBoundary from "./screens/Shared/ErrorBoundary";
import strings from "./global/constants/StringConstants";
import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";

// steps to override default smooth scrolling behaviour in browsers
declare global {
  interface Window {
    __forceSmoothScrollPolyfill__: boolean;
  }
}
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

const options = {
  api_host: strings.REACT_APP_PUBLIC_POSTHOG_HOST,
  autocapture: true,
  session_recording: {
    enabled: false,
  },
  capture_exceptions: {
    capture_unhandled_errors: true,
    capture_unhandled_rejections: true,
  },
};

// Initialize PostHog
if (typeof window !== "undefined") {
  posthog.init(strings.REACT_APP_PUBLIC_POSTHOG_KEY, options as any);
  
  // Ensure PostHog flushes data before tab closes
  window.addEventListener("beforeunload", () => {
    try {
      // Stop session recording to force flush any buffered data
      if (posthog.sessionRecording?.status === "active") {
        posthog.stopSessionRecording();
      }
    } catch (e) {
      console.error("Error flushing PostHog data on unload:", e);
    }
  });
}

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <React.StrictMode>
        <PostHogProvider
          apiKey={strings.REACT_APP_PUBLIC_POSTHOG_KEY}
          options={options as any}
        >
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </PostHogProvider>
      </React.StrictMode>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
